/**
 * RFC 4180-style CSV field escaping for server and client.
 */
export function escapeCsvField(value: string | number | boolean | null | undefined): string {
  if (value === null || value === undefined) return ''
  const s = typeof value === 'string' ? value : String(value)
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`
  }
  return s
}

/** Join rows (each row = array of cell values) into a CSV string. No trailing newline after last row unless rows empty. */
export function rowsToCsv(rows: Array<Array<string | number | boolean | null | undefined>>): string {
  return rows.map((row) => row.map(escapeCsvField).join(',')).join('\n')
}

/** Prefix for Excel UTF-8 recognition on Windows. */
export const CSV_UTF8_BOM = '\uFEFF'

export function withUtf8Bom(csvBody: string): string {
  return `${CSV_UTF8_BOM}${csvBody}`
}
